import { styled } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers-pro';

interface CustomPickerDayProps extends PickersDayProps<moment.Moment> {
  dayIsBetween: boolean;
  isFirstDay: boolean;
  isLastDay: boolean;
  absenceType: string;
  absenceStatus: string;
  dayIsBetweenLong: boolean;
  isFirstDayLong: boolean;
  isLastDayLong: boolean;
  isCurrentMonth: boolean;
  absenceStatusLong: string;
}

export const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop: string) =>
    prop !== 'dayIsBetween' &&
    prop !== 'isFirstDay' &&
    prop !== 'isLastDay' &&
    prop !== 'absenceType' &&
    prop !== 'absenceStatus' &&
    prop !== 'dayIsBetweenLong' &&
    prop !== 'isFirstDayLong' &&
    prop !== 'isLastDayLong' &&
    prop !== 'isCurrentMonth' &&
    prop !== 'absenceStatusLong',
})<CustomPickerDayProps>(
  ({
    theme,
    dayIsBetween,
    isFirstDay,
    isLastDay,
    absenceType,
    absenceStatus,
    dayIsBetweenLong,
    isFirstDayLong,
    isLastDayLong,
    isCurrentMonth,
    absenceStatusLong,
  }) => {
    let backgroundColor;
    if (!absenceType) {
      backgroundColor = theme.palette.primary.main;
    } else {
      switch (absenceType) {
        case 'HOLIDAY':
          backgroundColor = '#43a047';
          break;
        case 'MILITARY_REHEARSAL':
          backgroundColor = '#a06a34';
          break;
        case 'SICK_LEAVE':
          backgroundColor = '#d70000';
          break;
        case 'PUBLIC_HOLIDAY':
          backgroundColor = '#196400';
          break;
        default:
          backgroundColor = '#1457cb';
          break;
      }
    }

    const opacity = absenceStatus === 'APPROVED' ? 1 : 0.5;
    const opacityLong = absenceStatusLong === 'APPROVED' ? 1 : 0.5;

    return {
      ...(dayIsBetween &&
        isCurrentMonth && {
          borderRadius: 0,
          backgroundColor,
          opacity,
          color: theme.palette.common.white,
          '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
          },
        }),
      ...(isFirstDay &&
        isCurrentMonth && {
          borderTopLeftRadius: '50%',
          borderBottomLeftRadius: '50%',
        }),
      ...(isLastDay &&
        isCurrentMonth && {
          borderTopRightRadius: '50%',
          borderBottomRightRadius: '50%',
        }),
      ...(dayIsBetweenLong &&
        isCurrentMonth && {
          borderRadius: 0,
          backgroundColor: 'purple',
          opacity: opacityLong,
          color: theme.palette.common.white,
          '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
          },
        }),
      ...(isFirstDayLong &&
        isCurrentMonth && {
          borderTopLeftRadius: '50%',
          borderBottomLeftRadius: '50%',
        }),
      ...(isLastDayLong &&
        isCurrentMonth && {
          borderTopRightRadius: '50%',
          borderBottomRightRadius: '50%',
        }),
    };
  },
) as React.ComponentType<CustomPickerDayProps>;
